module.exports = __webpack_public_path__ + "img/Argyll_&_Bute.ab3e664b.png";